import {Injectable} from '@angular/core';

import {ActivatedRouteSnapshot, Resolve} from '@angular/router';
import {TabReportService} from '../_services/tab-report.service';

@Injectable()
export class ReportResolver implements Resolve<any> {
    constructor(private tabReportService: TabReportService) {
    }

    resolve(route: ActivatedRouteSnapshot) {
        return this.tabReportService.get(route.paramMap.get('reportId'));
    }
}
